import React, {useEffect} from "react";
import {Col, Row} from "reactstrap";
import {connect} from "react-redux";
import {addUserToTenant, deleteUserFromTenant, getTenant} from "store/actions/Tenants";
import {bindActionCreators} from "redux";
import {RootState} from "../../store/store";
import {GetRouterQuery} from '../../components/Utils/GetRouterQuery'
import {getUsers} from "store/actions/Users";
import TenantTab from "./TenantTab";
import TenantUsers from "./TenantUsers";
import RevenueCard from "components/RevenueCard";
import OutstandingCard from "components/OutstandingCard";
import ProfitCard from "components/ProfitCard";
import PageMeta from "components/PageMeta";
import {TenantState} from 'store/reducers/Tenants';
import {UsersState} from 'store/reducers/Users';
import LastQCard from "../../components/LastQCard";
import TenantPushNotifications from "./TenantPushNotifications";
import TenantAttachmentRequirements from "./TenantAttachmentRequirements";
import TenantInvoiceSettings from "./TenantInvoiceSettings";
import TenantOverviewCard from "./TenantOverviewCard";
import TenantURLSettings from "./TenantURLSettings";
import {Link} from "react-router-dom";
import {useOfficeTranslation} from "i18n/OfficeTranslation";

interface Props {
    tenantState: TenantState;
    usersState: UsersState;
}

interface Actions {
    getTenant: (id: string) => void;
    getUsers: () => void;
}

const TenantDetail: React.FC<Props & Actions> = ({ usersState, getUsers, tenantState, getTenant }) => {
    const {t} = useOfficeTranslation();

    const { id } = GetRouterQuery<{ id: string }>()

    useEffect(() => {
        getUsers();
        getTenant(id);
    }, [getUsers, getTenant, id])

    const tenant = tenantState.getTenantById(id);
    if (tenant === null) {
        return <></>
    }


    return (
        <>
            <PageMeta title={`${tenant.name} | ${t("common.tenants")}`} />
            <div className="page-content">
                <div className="page-title-box d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <div>
                        <Link to="/tenants" className="text-muted">
                            <i className="mdi mdi-arrow-left me-1" />{t("common.tenants")}
                        </Link>
                        <h4 className="mt-2 mb-1">{tenant.name}</h4>
                        <p className="text-muted mb-0">
                            {t("tenants.tenantDetail.manageBillingRequirementsAccessAndActivityForThisTenant")}
                        </p>
                    </div>
                    <div className="avatar-sm">
                        {tenant.layout.logo
                            ? <div dangerouslySetInnerHTML={{ __html: tenant.layout.logo }} />
                            : <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-24">
                                {tenant.name.charAt(0).toUpperCase()}
                            </span>}
                    </div>
                </div>

                <Row className="g-4 mb-4">
                    <Col xl={3} md={6}><RevenueCard tenantId={id} /></Col>
                    <Col xl={3} md={6}><ProfitCard tenantId={id} /></Col>
                    <Col xl={3} md={6}><OutstandingCard tenantId={id} /></Col>
                    <Col xl={3} md={6}><LastQCard tenantId={id} /></Col>
                </Row>

                <Row className="g-4 align-items-start">
                    <Col xl={4} lg={5}>
                        <TenantOverviewCard tenant={tenant} />
                        <TenantPushNotifications tenantId={id} />
                        <TenantUsers users={usersState.getUsers()} tenant={tenant} />
                    </Col>

                    <Col xl={8} lg={7}>
                        <TenantURLSettings tenant={tenant} />
                        <TenantInvoiceSettings tenant={tenant} />
                        <TenantAttachmentRequirements tenantId={id} />
                        <TenantTab />
                    </Col>
                </Row>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        usersState: state.Users,
        tenantState: state.Tenants
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ getTenant, getUsers, addUserToTenant, deleteUserFromTenant }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TenantDetail);
